/* eslint-disable react/display-name */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import { Grid, Slide, SlideProps } from '@quillbot/design-system';
import React, {
  createContext,
  Dispatch,
  forwardRef,
  MutableRefObject,
  SetStateAction,
  useContext,
  useRef,
} from 'react';
import { IsVisible, IsVisibleProps } from 'src/researcher/component/common/IsVisible';

export type TypeOfSliders = 'none' | 'templates' | 'trash-bin';

const SliderVisibility = createContext<
  [TypeOfSliders, Dispatch<SetStateAction<TypeOfSliders>>] | null
>(null);

export const SliderVisibilityProvider = (props: React.PropsWithChildren<any>) => {
  const sd = React.useState<TypeOfSliders>('none');
  return <SliderVisibility.Provider value={sd}>{props.children}</SliderVisibility.Provider>;
};

export const useSliderVisibility = () =>
  useContext(SliderVisibility) as [
    TypeOfSliders | null,
    Dispatch<SetStateAction<TypeOfSliders | null>>
  ];

export type SlideOwnProps = { sliderId: TypeOfSliders; containerRef?: any };

export const useIfSliderVisible = (sliderId: TypeOfSliders) => {
  const [slider] = useSliderVisibility();
  return slider === sliderId;
};

export function IsSliderShowing({
  sliderId,
  containerRef,
  ...props
}: SlideOwnProps & Partial<IsVisibleProps>) {
  const visible = useIfSliderVisible(sliderId);
  return (
    <IsVisible
      {...props}
      ref={containerRef}
      visible={typeof props.visible === 'boolean' ? props.visible : visible}
    />
  );
}

export const SliderBox = ({
  sliderId,
  ...props
}: Omit<SlideOwnProps, 'containerRef'> & Partial<SlideProps> & Pick<SlideProps, 'children'>) => {
  const [slider] = useSliderVisibility();
  const _in_ = slider === sliderId;
  return <Slide {...props} in={typeof props.in === 'boolean' ? props.in : _in_} direction="left" />;
};
